import React, { useState, useEffect } from 'react';
import './monitoramento.css';
import SidebarSisboard from '../../../components/sidebar/sidebar';
import Topbar from '../../../components/topbar/topbar';
import { useFetch } from '../../../components/hooks/useFetch';
import { Prefix } from '../../../services/prefix';
import { MdWarning } from "react-icons/md";
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import { MdFullscreen, MdFullscreenExit, MdVisibility, MdVisibilityOff } from "react-icons/md";

const Monitoramento = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('ALL');
  const [filterClient, setFilterClient] = useState('ALL');
  const [filterNeighborhood, setFilterNeighborhood] = useState('ALL');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [fullScreen, setFullScreen] = useState(false);
  const [hideHeaderTexts, setHideHeaderTexts] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const { data, error } = useFetch(
    `${Prefix.replace(/[\\"]/g, '')}/sismogran/map/customers?refresh=${refreshKey}`
  );

  const situationLabels = {
    DARK: 'Desligado',
    DANGER: 'Alerta',
    WARNING: 'Atenção',
    SUCCESS: 'Online',
    OFFLINE: 'Offline'
  };

  const situationColors = {
    DARK: '#000',
    DANGER: '#d9534f',
    WARNING: '#f0ad4e',
    SUCCESS: '#5cb85c',
    OFFLINE: '#6c5a6d'
  };

  const getPriority = (situation) => {
    switch (situation?.toUpperCase()) {
      case 'DARK': return 1;
      case 'DANGER': return 2;
      case 'WARNING': return 3;
      case 'SUCCESS': return 4;
      default: return 5;
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshKey(prev => prev + 1);
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (data) {
      const sorted = (data.models || []).sort(
        (a, b) => getPriority(a.situation) - getPriority(b.situation)
      );
      setCustomers(sorted);
      setLoading(false);
    }
  }, [data]);

  const handleChipClick = (status) => {
    setFilterStatus(prev => (prev === status ? 'ALL' : status));
  };

  const filteredCustomers = customers.filter(c => {
    if (filterStatus === 'OFFLINE') {
      if (!(c.situations.DARK > 0 &&
        c.situations.SUCCESS === 0 &&
        c.situations.WARNING === 0 &&
        c.situations.DANGER === 0)) return false;
    } else {
      if (filterStatus !== 'ALL' && (c.situations[filterStatus] || 0) === 0) return false;
    }
    if (filterClient !== 'ALL' && (c.fantasy_name || c.name) !== filterClient) return false;
    if (filterNeighborhood !== 'ALL' && (c.neighborhood || '').toLowerCase() !== filterNeighborhood.toLowerCase()) return false;
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      if (!(
        (c.name || '').toLowerCase().includes(term) ||
        (c.fantasy_name || '').toLowerCase().includes(term) ||
        (c.address || '').toLowerCase().includes(term) ||
        (c.number || '').toString().toLowerCase().includes(term) ||
        (c.neighborhood || '').toLowerCase().includes(term) ||
        (c.zipcode || '').toLowerCase().includes(term) ||
        (c.phone1 || '').toLowerCase().includes(term) ||
        (c.message || '').toLowerCase().includes(term)
      )) return false;
    }
    return true;
  });

  const filteredTotalStatus = filteredCustomers.reduce((acc, c) => {
    acc.SUCCESS = (acc.SUCCESS || 0) + (c.situations.SUCCESS || 0);
    acc.WARNING = (acc.WARNING || 0) + (c.situations.WARNING || 0);
    acc.DANGER = (acc.DANGER || 0) + (c.situations.DANGER || 0);
    acc.DARK = (acc.DARK || 0) + (c.situations.DARK || 0);
    acc.OFFLINE = (acc.OFFLINE || 0) + ((c.situations.DARK > 0 && c.situations.SUCCESS === 0 && c.situations.WARNING === 0 && c.situations.DANGER === 0) ? 1 : 0);
    return acc;
  }, {});

  return (
    <div className={`wrapper d-flex align-items-stretch ${fullScreen ? 'fullscreen-mode' : ''}`}>
      {!fullScreen && <SidebarSisboard />}
      <div id="content" className={fullScreen ? 'full-content' : ''}>
        {!fullScreen && <Topbar />}
        <div className="content_all">
          <div className="page-header">
            <div className='header'>
              {!hideHeaderTexts && (
                <div style={{marginLeft: -20}}>
                  <h1 className="page-title">Monitoramento</h1>
                  <p className="page-subtitle">Acompanhe em tempo real os contratos e seus sensores</p>
                </div>
              )}
              <div className="dashboard-status-chips between">
                {Object.keys(filteredTotalStatus).map(status => (
                  <div
                    key={status}
                    className={`status-chip ${filterStatus === status ? 'active' : ''}`}
                    style={{ backgroundColor: situationColors[status] }}
                    onClick={() => handleChipClick(status)}
                  >
                    <span className="status-title">{situationLabels[status]}</span>
                    <span className="status-count">{filteredTotalStatus[status] || 0}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="filters-dashboard">
              <div className="filter-group">
                <small>Buscar</small> <br />
                <input
                  type="text"
                  placeholder="Buscar por nome, endereço, telefone, bairro..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
              </div>

              <div className="filter-group">
                <small>Status</small>
                <select
                  className="client-filter"
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                >
                  <option value="ALL">Todos os Status</option>
                  <option value="DARK">Desligado</option>
                  <option value="DANGER">Alerta</option>
                  <option value="WARNING">Atenção</option>
                  <option value="SUCCESS">Ligado</option>
                  <option value="OFFLINE">Offline</option>
                </select>
              </div>

              <div className="filter-group">
                <small>Cliente</small>
                <select
                  className="client-filter"
                  value={filterClient}
                  onChange={(e) => setFilterClient(e.target.value)}
                >
                  <option value="ALL">Todos os Clientes</option>
                  {customers.map(c => c.fantasy_name || c.name).filter(Boolean).map((name, i) => (
                    <option key={i} value={name}>{name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="buttons-panel">
            <button
              className="fullscreen-toggle-btn"
              onClick={() => setFullScreen(!fullScreen)}
            >
              {fullScreen ? <MdFullscreenExit size={24} /> : <MdFullscreen size={24} />}
            </button>
            <button
              className="header-toggle-btn"
              onClick={() => setHideHeaderTexts(!hideHeaderTexts)}
            >
              {hideHeaderTexts ? <MdVisibility size={24} /> : <MdVisibilityOff size={24} />}
            </button>
          </div>

          <div className="container-sensor" style={{ marginTop: 20 }}>
            {loading && <p>Carregando dados...</p>}
            {error && <p>Erro ao carregar dados</p>}
            {!loading && filteredCustomers.length === 0 && (
              <div className="empty-filter">
                <h3>Nenhum resultado encontrado</h3>
                <p>Não encontramos contratos que correspondam aos filtros ou à pesquisa.</p>
              </div>
            )}
            {!loading && filteredCustomers.map((item) => (
              <Link
                key={item.id}
                className={`card-sensor status-${item.situation.toLowerCase()}`}
                to={{
                  pathname: "/monitoramento/cliente/info",
                  state: { customer: item }, 
                }}
              >
                <div className="card-header-item">
                  <div className="header-texts">
                    <h2>{item.fantasy_name || item.name}</h2>
                  </div>

                  {item.situations.DARK > 0 &&
                    item.situations.SUCCESS === 0 &&
                    item.situations.WARNING === 0 &&
                    item.situations.DANGER === 0 && (
                      <div className="pulse-alert">
                        <MdWarning className="pulse-icon" />
                        <span className="pulse-wave pulse-wave-1"></span>
                        <span className="pulse-wave pulse-wave-2"></span>
                        <span className="pulse-wave pulse-wave-3"></span>
                      </div>
                    )}
                </div>
                <div className="chip-container">
                  <div className="chip success">
                    <img src="/media/icons/green-light.svg" alt="success" />
                    <span>{item.situations.SUCCESS || '--'}</span>
                  </div>
                  <div className="chip warning">
                    <img src="/media/icons/yellow-light.svg" alt="warning" />
                    <span>{item.situations.WARNING || '--'}</span>
                  </div>
                  <div className="chip danger">
                    <img src="/media/icons/red-light.svg" alt="danger" />
                    <span>{item.situations.DANGER || '--'}</span>
                  </div>
                  <div className="chip dark">
                    <img src="/media/icons/black-light.svg" alt="dark" />
                    <span>{item.situations.DARK || '--'}</span>
                  </div>
                </div>

              </Link>

            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Monitoramento;
